import * as React from 'react';
import { BsSearch } from 'react-icons/bs';
import { MdCancel } from 'react-icons/md';
import { ThemeContext } from '../../context/theme.context';
import Message from '../../utils/Message/Message';
import GlobalGrid from '../../components/GlobalGrid';
import {
  ButtonComponent,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import axios from 'axios';
import { all_information, loadingShow, serviceUrl } from '../../App';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { getBusinessLogicConfiguration } from '../../services/Dig/BusinessLogicConfiguration/BusinessLogicConfigurationServices';
var resultLikeQuery = '';
var theQuerySearch = '';
var searchText: string = '';
var the_current_query: string = '';
const AssetCost = () => {
  const context = React.useContext(ThemeContext);
  const [current_query, setCurrent_query] = React.useState('');
  const template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='work_orders'
          autocomplete='off'
          input={inputEnterPress.bind(this)}
          showClearButton
          placeholder='Search'
          onChange={(args: any) => {
            searchText = args.target.value;
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={context.isDarkMode ? '#eaeaea' : '#292525'}
            className={'searchIcon'}
            onClick={search.bind(this)}
          />
        </div>
      </div>
    );
  };
  const templateAsyncButton = () => {
    return (
      <div>
        <ButtonComponent onClick={validatePM.bind(this)}>
          <AiOutlineCheckCircle size={24} />
          Vaidate PM Cost
        </ButtonComponent>
      </div>
    );
  };
  const toolbarOptions: any = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    { template: templateAsyncButton.bind(this) },
    'ColumnChooser',
    { template: template.bind(this), align: 'Right' },
  ];
  const inputEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  };
  const removeSearch = () => {
    if (searchText !== '') {
      $('#asset_cost').val();
      searchText = '';
      if (resultLikeQuery !== '') {
        resultLikeQuery = '';
        buildQuery();
      }
    }
  };
  const buildQuery = () => {
    the_current_query = current_query;
    the_current_query = the_current_query.replace(the_current_query, '');

    if (resultLikeQuery !== '') {
      if (the_current_query !== '') {
        theQuerySearch = ' and (' + resultLikeQuery + ')';
        the_current_query = the_current_query + theQuerySearch;
      } else {
        theQuerySearch = ' (' + resultLikeQuery + ')';
        the_current_query = the_current_query + theQuerySearch;
      }
    }
    setCurrent_query(the_current_query);
  };
  const initial = () => {
    getBusinessLogicConfiguration({ org_id: all_information.company_id })
      .then((el) => {
        the_current_query = '';
        el.data.map((elin: any) => {
          if (
            elin.target_table === 'uw_order' &&
            elin.component_name === 'Cloud Planner'
          ) {
            the_current_query += elin.condition + ' and';
          }
        });

        the_current_query = the_current_query.replaceAll('=', '€');
        the_current_query = the_current_query.substring(
          0,
          the_current_query.lastIndexOf('and')
        );
        buildQuery();
      })
      .catch((er) => {
        Message.error("Can't acces business logic parameter");
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
        buildQuery();
      });
  };
  const search = () => {
    if (searchText !== '' || current_query !== '') {
      resultLikeQuery = '';
      if (searchText !== '') {
        theColumns.map((el: any, index: number) => {
          if (el.field !== 'priority_code') {
            resultLikeQuery += `${el.field} like '%${searchText}%' `;
            if (index !== theColumns.length - 1) {
              resultLikeQuery += 'or ';
            }
          }
        });
        resultLikeQuery = resultLikeQuery.replaceAll("'%", '@@@');
      }
      buildQuery();
    }
  };
  const theColumns = [
    {
      field: 'pm_id',
      headerText: 'PM ID',
      isPrimaryKey: true,
      allowEditing: false,
    },
    {
      field: 'description',
      headerText: 'Description',
      allowEditing: false,
    },

    {
      field: 'S_Material_Cost',
      headerText: 'S_Material_Cost',
      allowEditing: false,
      format: 'C2',
    },
    {
      field: 'S_Labour_Cost',
      textAlign: 'Left',
      headerText: 'S_Labour_Cost',
      allowEditing: false,
      format: 'C2',
    },
    {
      field: 'S_Other_Cost',
      textAlign: 'Left',
      headerText: 'S_Other_Cost',
      allowEditing: false,
      format: 'C2',
    },
    {
      field: 'T_Material_Cost',
      headerText: 'T_Material_Cost',
      editType: 'numericedit',
      allowEditing: true,
      format: 'C2',
    },
    {
      field: 'T_Labour_Cost',
      textAlign: 'Left',
      headerText: 'T_Labour_Cost',
      editType: 'numericedit',
      allowEditing: true,
      format: 'C2',
    },
    {
      field: 'T_Other_Cost',
      textAlign: 'Left',
      headerText: 'T_Other_Cost',
      editType: 'numericedit',
      allowEditing: true,
      format: 'C2',
    },
    {
      field: 'total',
      textAlign: 'Left',
      headerText: 'Total',
      format: 'C2',
      allowEditing: false,
    },
  ];
  React.useEffect(() => {
    $('#asset_cost').val(searchText);
  });
  const validatePM = (e: any) => {
    e.target.disabled = true;
    axios
      .get(
        process.env.REACT_APP_API_GLOBAL_URL +
          `asset-cost-model/asset_cost_unmatch`
      )
      .then((el) => {
        var obj = {
          unmatchedpms: [...el.data],
        };
        if (el.data) {
          if (el.data.length > 0) {
            axios
              .put(
                process.env.REACT_APP_API_GLOBAL_URL +
                  `asset-cost-model/asset_cost_delete`,
                obj
              )
              .then((res) => {
                loadingShow(false);
                e.target.disabled = false;
                if (res.data.message) {
                  if (res.data.message === 'Success') {
                    Message.success('Successfully');
                    let theTempQuery = current_query;
                    setCurrent_query(theTempQuery + ' ');
                  } else {
                    Message.error(res.data.message);
                  }
                }
              })
              .catch((err) => {
                e.target.disabled = false;
                loadingShow(false);
                if (err.response) {
                  Message.error(
                    err.response.data +
                      '\n' +
                      err.response.status +
                      '\n' +
                      err.response.headers
                  );
                } else if (err.request) {
                  Message.error(err.request);
                } else {
                  Message.error('Error: ' + err.message);
                }
              });
          } else {
            e.target.disabled = false;
          }
        } else {
          e.target.disabled = false;
        }
      })
      .catch((err) => {
        loadingShow(false);
        e.currentTarget.disabled = false;
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  };
  return (
    <div>
      <GlobalGrid
        columns={theColumns}
        height={'calc(-290px + 100vh)'}
        query={current_query}
        toolbarOptions={toolbarOptions}
        get_query={'asset-cost-estimation'}
        edit_query={'asset-cost-estimation/edit'}
        id={'asset-cost-grid'}
        isFitInCOntent={true}
        signalOfLoad={true}
      />
    </div>
  );
};

export default AssetCost;
